import axios from 'axios';

const SNAPSHOT_GRAPHQL_ENDPOINT = 'https://hub.snapshot.org/graphql';

export async function fetchSnapshotProposals(space = 'aave.eth', limit = 10) {
  const query = `
    query Proposals($space: String!, $limit: Int!) {
      proposals(
        first: $limit, 
        where: { space: $space },
        orderBy: "created",
        orderDirection: desc
      ) {
        id
        title
        body
        choices
        start
        end
        snapshot
        state
        author
        space {
          id
          name
        }
        votes
        scores
        scores_total
      }
    }
  `;

  try {
    const response = await axios.post(SNAPSHOT_GRAPHQL_ENDPOINT, {
      query,
      variables: { space, limit }
    });
    
    return response.data.data.proposals;
  } catch (error) {
    console.error('Error fetching Snapshot proposals:', error);
    throw new Error('Failed to fetch proposals');
  }
}

export async function fetchSpace(spaceId) {
  const query = `
    query Space($id: String!) {
      space(id: $id) {
        id
        name
        about
        network
        symbol
        members
      }
    }
  `;

  try {
    const response = await axios.post(SNAPSHOT_GRAPHQL_ENDPOINT, {
      query,
      variables: { id: spaceId }
    });
    
    return response.data.data.space;
  } catch (error) {
    console.error('Error fetching space:', error);
    return null;
  }
}